import store from '@/packages/vuex'
import { Middleware } from '@/app/router'

export default new Middleware('TasksEnabled', ({ next, router }) => {
	if (store.getters['Auth/user'].hasSomePermission('PARTS_QUANTITY_DISABLED')) {
		return next()

	} else {
		router.push({
			name: 'Dashboard:Home'
		})
	}
})
